import {Action} from '@ngrx/store';
import {UserInfo} from 'firebase';
import {HideLoader, ShowLoader} from '../../loading-indicator/store/decorators';

export const LOGIN = 'Authentication Login';
export const LOGIN_FINISHED = 'Authentication Finished';
export const LOGIN_FAILED = 'Authentication Failed';
export const SIGN_UP = 'Authentication SignUp';
export const SIGN_UP_FINISHED = 'Auth SignUp Finished';
export const SIGN_UP_FAILED = 'Auth SignUp Failed';
export const LOAD_USER = 'Auth load user ';
export const SIGN_OUT = 'Auth Sign Out';
export const SIGN_OUT_FINISHED = 'Auth Sign Out Finished';

@ShowLoader()
export class LoginAction implements Action {
  readonly type = LOGIN;

  constructor(public payload: { username: string, password: string }) {
  }
}

@HideLoader(LOGIN)
export class LoginFinished implements Action {
  readonly type = LOGIN_FINISHED;

  constructor(public payload: UserInfo) {
  }
}

@HideLoader(LOGIN)
export class LoginFailed implements Action {
  readonly type = LOGIN_FAILED;

  constructor(public payload: string) {
  }
}

export class SignUpAction implements Action {
  readonly type = SIGN_UP;

  constructor(public payload: { email: string, displayName: string, password: string }) {
  }
}

export class SignUpFinished implements Action {
  readonly type = SIGN_UP_FINISHED;

  constructor(public payload: UserInfo) {
  }
}

export class SignUpFailed implements Action {
  readonly type = SIGN_UP_FAILED;

  constructor(public payload: string) {
  }
}

export class LoadUserAction implements Action {
  readonly type = LOAD_USER;
}

export class SignOut implements Action {
  readonly type = SIGN_OUT;
}

export class SignOutFinished implements Action {
  readonly type = SIGN_OUT_FINISHED;
}


export type AuthActions =
  LoginAction | SignUpAction | SignUpFinished | SignOut | SignOutFinished |
  SignUpFailed | LoginFailed | LoginFinished | LoadUserAction;
